import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { RoleUsersCandidateListOptionRequest, AddUsersToRoleRequest, RemoveUsersFromRoleRequest } from '../models/roles';

@Injectable({
  providedIn: 'root'
})
export class RoleDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public checkNameExists(name: string, roleId?: number, timeout?: Promise<any>): Promise<boolean> {
    const data = { name: name, roleId: roleId };

    return this.httpClient.getJsonAsync<boolean>('roles/checkNameExists', data, timeout, false);
  }

  addUsersToRoleAsync(request: AddUsersToRoleRequest, timeout?: Promise<any>) {
    return this.httpClient.postJsonAsync('roles/AddUsers', request, timeout, false);
  }

  removeUsersFromRoleAsync(request: RemoveUsersFromRoleRequest, timeout?: Promise<any>) {
    return this.httpClient.postJsonAsync('roles/RemoveUsers', request, timeout, false);
  }

  getUserCandidatesAsync(roleId: number, searchTerm?: string, timeout?: Promise<any>) {
    const request = {
      roleId: roleId,
      searchString: searchTerm
    } as RoleUsersCandidateListOptionRequest;

    const wrapper = {
      request: JSON.stringify(request)
    };

    return this.httpClient.getJsonAsync<ListOption<number>[]>('roles/UserCandidates', wrapper, timeout, false);
  }
}
